<template>
  <ul class="pg-table-radio flex wrap">
    <template v-for="(d,i) in list">
      <li class="flex aic mr5" :key="'e'+i">
        <div class="icon mr5">
          <img :src="getSrc(d.value)" width="20" height="20" alt="">
        </div>
        <div class="mr5">{{ d.label }}</div>
        <div v-if="d.data&&inValue(d.value)">
          <img width="60" height="60" :src="d.data" alt="">
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: "pg-table-checkbox-pic",
  props: {
    value: [String, Number, Array],
    extra: {
      type: Array, default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    list() {
      const {data = []} = this;
      return data.map((r, i) => {
        if (typeof r === 'string') return {
          label: r,
          value: i
        }
        return {
          ...r,
          value: i
        }
      })
    }
  },
  methods: {
    getSrc(value) {
      return this.inValue(value) ? require('../../../../public/img/方形选中-fill.png') : require('../../../../public/img/方形未选中.png');
    },
    inValue(val) {
      if (Array.isArray(this.value))
        for (const valElement of this.value) {
          if (valElement == val) return true;
        }
      return false;
    }
  },
}
</script>

<style scoped lang="scss">
.pg-table-radio {
  li {
    min-height: 28px
  }
}

.icon {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  background-image: url('../../../../public/img/方形未选中.png');

  &.curr {
    background-image: url("../../../../public/img/方形选中-fill.png");
  }
}

input {
  text-align: center;
  width: 50px;
  font-size: 14px;
  border: 0px none;
  outline: none;
  border-bottom: 1px solid #333;
}
</style>